/**
 * The catalog of decision 0019: what each family of models is, read from `catalog/` through the
 * generated module. A model's family is its name between `iso-` and its variant: `iso-spruce-6`
 * is a spruce, `iso-house-a1` a house; a model's parts and riders (`iso-windmill-1-sails`) have
 * none.
 */
import { CATALOG } from "../generated/catalog.ts";
import type { FamilyDef } from "./types.ts";

export { CATALOG };

const BY_NAME: ReadonlyMap<string, FamilyDef> = new Map(CATALOG.families.map((f) => [f.name, f]));

/** The family a whole model belongs to, or null for parts and for models the catalog lacks. */
export function familyOf(model: string): FamilyDef | null {
  const name = /^iso-([a-z]+)(?:-[a-z]?\d+[a-z]?)?$/.exec(model)?.[1];
  return (name !== undefined && BY_NAME.get(name)) || null;
}

/** A family by its own name. */
export function family(name: string): FamilyDef | null {
  return BY_NAME.get(name) ?? null;
}
